import React from 'react';
import { DEFAULT_REACTIONS, ReactionConfig } from '~/types/reaction';

interface IProps {
  reactionsCount: number;
  byReactionUserIds: Record<string, string[]>;
  reactionsSorted?: string[];
  reactions?: ReactionConfig[];
}

const ReactionSummary = ({ reactionsCount, byReactionUserIds, reactionsSorted, reactions = DEFAULT_REACTIONS }: IProps) => {
  if (!reactionsCount) return null;

  const orderedKeys = reactionsSorted?.length
    ? Array.from(new Set(reactionsSorted)).filter((key) => (byReactionUserIds[key] || []).length > 0)
    : Object.keys(byReactionUserIds)
        .filter((key) => (byReactionUserIds[key] || []).length > 0)
        .sort((a, b) => (byReactionUserIds[b] || []).length - (byReactionUserIds[a] || []).length);

  const topTwo = orderedKeys.slice(0, 2);

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {topTwo.map((key) => {
        const config = reactions.find((r) => r.type === key);
        const count = (byReactionUserIds[key] || []).length;
        if (!config || !count) return null;
        return (
          <span
            key={key}
            style={{
              background: '#f5f5f5',
              border: '1px solid #ddd',
              borderRadius: 12,
              padding: '3px 6px',
              fontSize: 13,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 3
            }}
          >
            {config.imageUrl
              ? <img src={config.imageUrl} alt={config.type} style={{ width: 20, height: 20, objectFit: 'contain' }} />
              : <span style={{ fontSize: 14, lineHeight: 1 }}>{config.emoji}</span>
            }
            <span style={{ color: '#666', fontWeight: 600, fontSize: 12 }}>{count}</span>
          </span>
        );
      })}
      {reactionsCount > 0 && (
        <span style={{ fontSize: 12, color: '#666' }}>
          {reactionsCount} {reactionsCount === 1 ? 'reaction' : 'reactions'}
        </span>
      )}
    </div>
  );
};

export default ReactionSummary;
